import { Icon, IconProps } from "./Icon";

export function IconPool(props: IconProps) {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        d="M4 14h11v3h1V3a2 2 0 1 1 4 0h1a3 3 0 0 0-6 0v5H4V3a2 2 0 1 1 4 0h1a3 3 0 1 0-6 0v14h1v-3Zm11-5v4H4V9h11ZM4 18c-1.2 0-1.12 1-2 1-.88 0-.8-1-2-1v1c.8 0 .8 1 2 1s1.2-1 2-1 .8 1 2 1 1.2-1 2-1 .8 1 2 1 1.2-1 2-1 .8 1 2 1 1.2-1 2-1 .8 1 2 1 1.2-1 2-1v-1c-1.2 0-1.2 1-2 1s-.8-1-2-1-1.2 1-2 1-.8-1-2-1-1.2 1-2 1-.8-1-2-1-1.2 1-2 1-.8-1-2-1Zm4 4c-1.2 0-1.12 1-2 1-.88 0-.8-1-2-1v1c.8 0 .8 1 2 1s1.2-1 2-1 .8 1 2 1 1.2-1 2-1 .8 1 2 1 1.2-1 2-1 .8 1 2 1 1.2-1 2-1 .8 1 2 1 1.2-1 2-1v-1c-1.2 0-1.2 1-2 1s-.8-1-2-1-1.2 1-2 1-.8-1-2-1-1.2 1-2 1-.8-1-2-1-1.2 1-2 1-.8-1-2-1Z"
      />
    </Icon>
  );
}
